<template>
  <div>
    <!--    {{roles}}-->
    <v-select
      v-model="team"
      :items="teamOptions"
      item-text="name"
      item-value="code"
      label="Team"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'TeamSelector',
  props: {
    emitMode: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters(['teams']),
    team: {
      get () {
        return this.$store.state.team
      },
      set (value) {
        if (this.emitMode) {
          this.$emit('input', value)
        } else {
          this.$store.commit('SET_TEAM', value)
          this.$store.commit('SET_TEAM_WORKCLOSEDAYS', value ? (this.teams?.find(t => t.code === value)?.workCloseDays || []) : [])
        }
      }
    },
    roles () {
      return this.$store.state.roles
    },
    teamOptions () {
      const options = [...this.teams]
      if (this.roles && this.roles.includes('head')) {
        options.unshift({ name: 'All Teams', code: null })
      }
      return options
    }
  }
}
</script>

<style scoped>

</style>
